













































































import { IInputTab } from '@/components/global/common-models';
import { FormModalParams, FormModalSizeEnum } from '@/components/global/modal/form-modal-models';
import OtFormModal from '@/components/global/modal/ot-form-modal.vue';
import OtAutocomplete, { IAutocompleteItem } from '@/components/global/ot-autocomplete.vue';
import OtButton from '@/components/global/ot-button.vue';
import OtLoadingSpinner from '@/components/global/ot-loading-spinner.vue';
import OtTabs from '@/components/global/ot-tabs.vue';
import OtApi, { executeApi } from '@/services/api.service';
import {
  AconexInteractionStatus as ApiAconexInteractionStatus,
  GetAconexProjectsResponseProjectModel as ApiGetAconexProjectsResponseProjectModel,
  GetSearchAconexDocumentsResponseDocumentModel as ApiGetSearchAconexDocumentsResponseDocumentModel,
  GetSearchAconexMailResponseMailModel as ApiGetSearchAconexMailResponseMailModel,
} from '@/services/generated/api';
import { vxm } from '@/store';
import { IVForm } from '@/utils/type-utils';
import { Component, Ref, Vue } from 'vue-property-decorator';
import {
  AddEditDocumentDialogParams,
  AddEditDocumentDialogResult,
} from '../add-edit-document-dialog/add-edit-document-dialog-models';
import { AconexImportDialogParams, AconexImportDialogResult } from './aconex-import-dialog-models';
import OtAconexDocumentList from './ot-aconex-document-list.vue';
import OtAconexMailList from './ot-aconex-mail-list.vue';

@Component({
  components: {
    OtFormModal,
    OtButton,
    OtLoadingSpinner,
    OtAutocomplete,
    OtTabs,
    OtAconexMailList,
    OtAconexDocumentList,
  },
})
export default class OtAconexImportDialog extends Vue {
  // * PROPS

  // * REFS
  @Ref('formModalRef') private readonly formModalRef!: OtFormModal;
  @Ref('modalContentRef') private readonly modalContentRef!: IVForm;

  // * DATA
  private api = new OtApi();
  private aconexProjects: IAutocompleteItem<ApiGetAconexProjectsResponseProjectModel>[] = [];
  private selectedProject: IAutocompleteItem<ApiGetAconexProjectsResponseProjectModel> | null = null;
  private selectedMail: ApiGetSearchAconexMailResponseMailModel | null = null;
  private selectedDocument: ApiGetSearchAconexDocumentsResponseDocumentModel | null = null;
  /** have we done a full validation run yet? */
  private hasValidated = false;

  // * COMPUTED
  private get dialogConfirmText() {
    console.log('dialogConfirmText', {
      hasProj: this.hasSelectedProject,
      hasMail: !!this.selectedMail,
      hasDoc: !!this.selectedDocument,
    });
    if (
      !this.hasSelectedProject ||
      (this.isActiveTabDocuments && !this.selectedDocument) ||
      (this.isActiveTabMail && !this.selectedMail)
    ) {
      return 'Import';
    }

    return `Import Selected ${this.isActiveTabDocuments ? 'Document' : 'Mail'}`;
  }
  private get dialogTitle() {
    if (!this.hasSelectedProject) {
      return 'Select Aconex Project';
    }
    return `Select ${this.isActiveTabDocuments ? 'document' : 'mail'} from Aconex Project`;
  }

  private tabsData: IInputTab[] = [
    { tabId: 0, tabText: 'Documents' },
    { tabId: 1, tabText: 'Mail' },
  ];

  private get hasSelectedProject() {
    return Boolean(this.selectedProject);
  }
  private get selectedAconexProjectId() {
    return this.selectedProject?.data?.id;
  }

  private activeTabPrivate = 0;
  private get activeTab() {
    return this.activeTabPrivate;
  }
  private set activeTab(value: number) {
    this.activeTabPrivate = value;
    this.hasValidated = false;
    this.selectedDocument = null;
    this.selectedMail = null;
  }

  private get isActiveTabDocuments() {
    return this.hasSelectedProject && this.activeTab === 0;
  }
  private get isActiveTabMail() {
    return this.hasSelectedProject && this.activeTab === 1;
  }

  private get showSelectMailError() {
    return this.hasValidated && this.isActiveTabMail && this.selectedMail === null;
  }
  private get showSelectDocumentError() {
    return this.hasValidated && this.isActiveTabDocuments && this.selectedDocument === null;
  }
  private get showSelectProjectError() {
    return this.hasValidated && this.selectedProject === null;
  }

  // * WATCHERS

  // * METHODS
  public async validate() {
    //blurCombos(this.$refs.documentContentCombo);
    this.hasValidated = true;

    // wait for a re-render so we absotively posilutely have the values where they should be
    await this.$nextTick();

    let isValid = true;
    isValid =
      this.hasSelectedProject &&
      ((this.isActiveTabDocuments && Boolean(this.selectedDocument)) ||
        (this.isActiveTabMail && Boolean(this.selectedMail)));

    return isValid;
  }

  private params: AconexImportDialogParams | null = null;
  private isLoading = false;

  private async initialise(params: AconexImportDialogParams) {
    this.isLoading = true;

    // remember these for other spots we need them
    this.params = params;
    // dunno why. Just feels like we should wait
    await this.$nextTick();

    await this.loadAconexProjects();

    this.hasValidated = false;
    this.selectedDocument = null;
    this.selectedMail = null;

    this.isLoading = false;
  }
  public async open(params: AconexImportDialogParams): Promise<AconexImportDialogResult> {
    // if (!params.validate()) {
    //   console.error('ot-add-edit-document-dialog -> open -> invalid params, bailing', params);
    //   return new AddEditDocumentDialogResult({});
    // }

    // HACK I'd like to use null here, but that causes the compiler to contune to think that this will be null
    // FOREVER, and gives it the never type. Which means when we go to check the .ok property, the compiler
    // errors with "Property 'ok' does not exist on type 'never'"
    // Which, sucks. So, we'll make a pre built object pretending like they hit cancel on the dialog
    // We don't need the exra nuance of being able to say "it's still null, they never clicked OK on the outer dialog"
    // because we actually have the outer dialog result as well. I'd still like to use null, it's cleaner, but this works.
    // let addEditDocumentResult: AddEditDocumentDialogResult | null = null;
    let addEditDocumentResult = new AddEditDocumentDialogResult({ ok: false });

    const baseParams = new FormModalParams({
      title: '', // we set the title on the prop, not here
      formRef: this.modalContentRef,
      cancelText: 'Cancel',
      size: FormModalSizeEnum.Max,
      contentHandlesOwnScrolling: true,
      onValidate: this.validate,
      onAfterFormMounted: () => this.initialise(params),
      onBeforeConfirmClose: async () => {
        const newParams = new AddEditDocumentDialogParams(params.documentParams);

        if (this.isActiveTabMail) {
          const metadataResult = await executeApi(
            // if we're in here, we've passed validation, which means there's a selected mail and project
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            () => this.api.aconex().getAconexMailMetadata(this.selectedAconexProjectId!, this.selectedMail!.mailId),
            'Loading Aconex mail',
          );
          if (metadataResult.success && metadataResult.data?.result) {
            newParams.aconexMail = metadataResult.data.result;
          }
        } else if (this.isActiveTabDocuments) {
          const metadataResult = await executeApi(
            () =>
              this.api
                .aconex()
                // if we're in here, we've passed validation, which means there's a selected document and project
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                .getAconexDocumentMetadata(this.selectedAconexProjectId!, this.selectedDocument!.documentId),
            'Loading Aconex document',
          );
          if (metadataResult.success && metadataResult.data?.result) {
            newParams.aconexDocument = metadataResult.data.result;
          }
        }
        newParams.aconexProjectId = this.selectedAconexProjectId!;
        addEditDocumentResult = await vxm.modal.openAddEditDocumentDialog(newParams);
        // Hmm. Should we keep this outer open if they hit cancel on the inner?
        // I thin we probably should
        // That way they can pick a dialog, get to the create dialog, go "oh, crap, wrong one", hit cancel, get back to here
        // Means if they go "screw this noise" and cancel on the inner, they have to cancel on this one too. Oh well
        // And, the ENG says exactly this too, so this has been double confirmed to be A Good Idea
        return addEditDocumentResult.ok;
      },
    });

    const result = await this.formModalRef.open(baseParams);

    if (result.ok) {
      // they clicked OK on this outer dialog
      if (addEditDocumentResult.ok) {
        // they clicked OK on the add/edit document dialog
        return new AconexImportDialogResult({
          didImport: true,
          result: addEditDocumentResult,
        });
      } else {
        // they clicked OK on this outer dialog, but cancel on the inner dialog
        return new AconexImportDialogResult({ didImport: false });
      }
    }
    return new AconexImportDialogResult({ didImport: false });
  }

  private async loadAconexProjects() {
    const projectResponse = await executeApi(() => this.api.aconex().getAconexProjects(), 'Loading Aconex projects');
    if (
      projectResponse.success &&
      projectResponse.data?.aconexInteractionStatus === ApiAconexInteractionStatus.Success &&
      projectResponse.data.result
    ) {
      this.aconexProjects = projectResponse.data.result.map(p => ({
        label: this.getAconexProjectLabel(p),
        data: p,
      }));
    }
    return Promise.resolve();
  }

  private getAconexProjectLabel(project: ApiGetAconexProjectsResponseProjectModel) {
    // this was a thought. I don't know what a normal short name looks like, but for our one testing project, it's just the name truncated
    // which looks dumb when presented like this. So I'm not doing it. True story. Movie rights negotiations pending.
    /*if (project.name && project.shortName) {
      return `${project.name} (${project.shortName})`;
    } else*/

    return project.name || project.shortName || project.id || '';
  }

  private onMailSelect(item: ApiGetSearchAconexMailResponseMailModel) {
    console.log('onMailSelect', item);
    this.selectedMail = item;
    this.hasValidated = false;
    this.selectedDocument = null;
  }
  private onDocumentSelect(item: ApiGetSearchAconexDocumentsResponseDocumentModel) {
    console.log('onDocumentSelect', item);
    this.selectedDocument = item;
    this.hasValidated = false;
    this.selectedMail = null;
  }

  // * LIFECYCLE
}
